/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { ReactNode } from 'react';
import { Box, IBoxProps, useColorMode } from 'native-base';
import { useAppSettings, useSpringBigStore } from '@springbig/shared';
import { useGeneralStyles } from './styles';
import Image from './Image';
import { useLocation } from 'react-router';
import PageHeaderV2 from './PageHeader';

interface IBoxSectionProps extends IBoxProps {
    bannerPaddingTop?: number;
    pageHeaderChildren?: ReactNode;
}
const Section = ({ children, pageHeaderChildren, ...props }: IBoxSectionProps) => {

    const { lightBackground, darkBackground } = useSpringBigStore();
    const { hasCustomBackground, screenBanners, pageHeaders, pageBackgrounds } = useAppSettings();
    const gStyle = useGeneralStyles();
    const { colorMode } = useColorMode();
    const location = useLocation();
    const currentPath = location.pathname;
    const name = currentPath.split('/').slice(3).join('/');

    // TODO: I gave control to Layout over the background (which fixes a lot of issues)
    // when we have time, remove this component and give Layout control over the background image
    // as well.

    const Banner = () => {

        if (screenBanners && screenBanners?.length > 0) {
            const _banner = screenBanners.find(el => el.screen.toLowerCase() === currentPath.split('/')[3]);
            if (_banner) {
                return (
                    <Box
                        w={'100%'}
                        h={32}
                    >
                        <Image uri={_banner.bannerUrl} width={'100%'} h={32} resizeMode={'cover'} />
                    </Box>
                );
            }

            return <Box></Box>;
        }

        return <Box></Box>;
    };

    const _PageHeader = () => {

        if (pageHeaders) {
            const pageHeaderConfigKey = Object.keys(pageHeaders).filter((e) => e.toLowerCase() === name).at(0);
            const pageHeaderConfig = pageHeaders[pageHeaderConfigKey];
            if (pageHeaderConfig && pageHeaderConfig.show) {
                return (
                    <PageHeaderV2 config={pageHeaderConfig}>{pageHeaderChildren}</PageHeaderV2>
                );
            }
        }

        return <></>;
    };

    const body = <>
        <Banner />
        <_PageHeader />
        {children}
    </>;

    const _PageBackground = ({ backgroundUrl }: { backgroundUrl: string }) => {

        return (
            <>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    height: '100%',
                    width: '100%',
                    backgroundImage: `url(${backgroundUrl})`,
                    backgroundSize: 'cover',
                }}>
                </div>
                <Box {...props} bg={'transparent'} >
                    {body}
                </Box>
            </>
        );

    };

    if ((hasCustomBackground && (lightBackground || darkBackground)) || pageBackgrounds) {
        if (pageBackgrounds) {
            let pageBackgroundConfigKey = Object.keys(pageBackgrounds).filter((e) => e.toLowerCase() === name).at(0);
            // The auth page has no name so we added this
            if (name === '') {
                pageBackgroundConfigKey = 'auth';
            }

            const pageBackgroundConfig = pageBackgrounds[pageBackgroundConfigKey];
            if (pageBackgroundConfig && (pageBackgroundConfig.light || pageBackgroundConfig.dark)) {
                return <_PageBackground backgroundUrl={colorMode === 'light' ? pageBackgroundConfig.light : pageBackgroundConfig.dark} />;
            }
        }

        return <_PageBackground backgroundUrl={colorMode === 'light' ? lightBackground : darkBackground} />;
    }

    return <Box
        bg={gStyle.screen_background}
        {...props}
    >
        {body}
    </Box>;

};

export default Section;
